// extracted by mini-css-extract-plugin
module.exports = {"inner":"cd01fbf7b5--inner--ag3lA","title":"cd01fbf7b5--title--FqGvO","content":"cd01fbf7b5--content--SmhjY","footer":"cd01fbf7b5--footer--R0ITF"};